import requests from "./httpService";

// Meetings module (/api/v1/meetings). Company and user come from the login token.
const query = (params = {}) =>
  Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");

const MeetingsServices = {
  getMeetings(params) {
    return requests.get(`/meetings/all?${query(params)}`);
  },
  getDeletedMeetings(params) {
    return requests.get(`/meetings/deleted?${query(params)}`);
  },
  getMeeting(id) {
    return requests.get(`/meetings/${id}`);
  },
  createMeeting(body) {
    return requests.post(`/meetings/create`, body);
  },
  startAdhoc(body) {
    return requests.post(`/meetings/adhoc`, body);
  },
  updateMeeting(id, body) {
    return requests.post(`/meetings/update/${id}`, body);
  },
  setAttendees(id, attendees) {
    return requests.post(`/meetings/attendees/${id}`, { attendees });
  },
  attendeeOptions(params) {
    return requests.get(`/meetings/attendee-options?${query(params)}`);
  },
  attendeeTasks(userIds) {
    return requests.get(`/meetings/attendee-tasks?${query({ user_ids: userIds.join(",") })}`);
  },
  attendeeProjects(userIds) {
    return requests.get(`/meetings/attendee-projects?${query({ user_ids: userIds.join(",") })}`);
  },
  // which of these people are in another meeting at that time: { user_ids: [..], start: ISO, duration, exclude_id }
  busy({ user_ids: userIds, ...rest }) {
    return requests.get(`/meetings/busy?${query({ ...rest, user_ids: userIds.join(",") })}`);
  },
  projectInfo(projectIds) {
    return requests.get(`/meetings/project-info?${query({ ids: projectIds.join(",") })}`);
  },
  startMeeting(id) {
    return requests.post(`/meetings/start/${id}`);
  },
  endMeeting(id, body) {
    return requests.post(`/meetings/end/${id}`, body);
  },
  deleteMeeting(id) {
    return requests.delete(`/meetings/delete/${id}`);
  },
  restoreMeeting(id) {
    return requests.post(`/meetings/restore/${id}`);
  },

  createSeries(body) {
    return requests.post(`/meetings/series/create`, body);
  },
  getSeries(id) {
    return requests.get(`/meetings/series/${id}`);
  },
  updateSeries(id, body) {
    return requests.post(`/meetings/series/update/${id}`, body);
  },
  stopSeries(id) {
    return requests.post(`/meetings/series/stop/${id}`);
  },

  getSuggestions(id) {
    return requests.get(`/meetings/${id}/suggestions`);
  },
  dismissSuggestion(id, taskId) {
    return requests.post(`/meetings/${id}/suggestions/dismiss`, { task_id: taskId });
  },
  addAgendaItems(id, items) {
    return requests.post(`/meetings/${id}/agenda/add`, { items });
  },
  updateAgendaItem(itemId, body) {
    return requests.post(`/meetings/agenda/update/${itemId}`, body);
  },
  setCovered(itemId, covered) {
    return requests.post(`/meetings/agenda/covered/${itemId}`, { covered });
  },
  reorderAgenda(id, itemIds) {
    return requests.post(`/meetings/${id}/agenda/reorder`, { item_ids: itemIds });
  },
  deleteAgendaItem(itemId) {
    return requests.delete(`/meetings/agenda/delete/${itemId}`);
  },
  promoteAgendaItem(itemId, taskId) {
    return requests.post(`/meetings/agenda/promote/${itemId}`, { task_id: taskId });
  },

  // the meeting's record of a task change made (through the task API) while it was in progress
  recordTaskUpdate(id, body) {
    return requests.post(`/meetings/${id}/task-updates`, body);
  },
  getMeetingTaskUpdates(id) {
    return requests.get(`/meetings/${id}/task-updates`);
  },
  getTaskHistory(taskId) {
    return requests.get(`/meetings/task-history/${taskId}`);
  },
};

export default MeetingsServices;
